import registrationStep from "../../registrationStep";
import HunterPermit from "./HunterPermit";

export default registrationStep(HunterPermit, "hunter-permit", "id");



// WEBPACK FOOTER //
// ./src/registration/components/HunterPermit/index.js